import {init} from 'core/LifeCycle';
import {remoteControl} from 'services/remoteControl';
import {rewriteState} from 'setup/rewriteState';

type Dependencies = {
  remote?: RemoteControlService;
};

export function checkRemoteSettings(di: Dependencies = {}): void {
  const {remote = remoteControl} = di;

  const settings = remote.initialSettings();
  if (!settings) return;

  const {amount, daysCount} = settings;
  const state = init(amount, daysCount);
  rewriteState(state, {refresh: false});
  remote.cleanup();
}
